export default {"src":"https://dap-prod-3m8r9mc2a-dap-rewrite.vercel.app/_next/static/media/MyProfileChevronDown.43414bc1.svg","height":49,"width":48};